import clsx from "clsx";

import { isoDate, longDate, stampedDate } from "../lib/format";
import { variationFor } from "../lib/seed";

export type DateStampProps = {
  date: string | null;
  /** The entry id, so the angle and ink are stable for this find. */
  seedId: string;
  /** Overrides the stamp's caption. */
  label?: string;
  className?: string;
  size?: "sm" | "md";
};

/**
 * A rubber-stamped date: letterpressed, a few degrees off square, inked in
 * ochre or teal depending on the entry's seed, with faintly uneven coverage
 * from the shared `stamp` mask.
 */
export function DateStamp({ date, seedId, label, className, size = "md" }: DateStampProps) {
  const variation = variationFor(seedId);
  const ink = variation.stampInk === "ochre" ? "text-ochre" : "text-teal";

  return (
    <span
      className={clsx("inline-flex flex-col items-center", className)}
      style={{ transform: `rotate(${variation.stampRotation}deg)` }}
    >
      <span className={clsx("stamp letterpress", ink, size === "sm" ? "text-[0.5rem]" : "text-[0.625rem]")}>
        {label ? (
          <span className="mr-1.5 opacity-70">{label}</span>
        ) : null}
        <time dateTime={isoDate(date)} title={longDate(date)}>
          {stampedDate(date)}
        </time>
      </span>
    </span>
  );
}
